import { BaseError } from 'viem';
import {
  InsufficientFundsError,
  InternalRpcError,
  TransactionNotFoundError,
  UnknownRpcError,
} from 'viem';

// for L2 transactions, transaction cost has an L1 part of the fee and L2 part of the fee
// wallets only estimate the L2 part of the fee, but the rpc node will throw if the user doesn't have enough for the l1 fee
export function isInsufficientFundsError(error: unknown) {
  return (
    error instanceof BaseError &&
    error.walk(e => e instanceof InsufficientFundsError) instanceof InsufficientFundsError
  );
}

export function isUnknownRpcError(error: unknown) {
  return (
    error instanceof BaseError &&
    error.walk(e => e instanceof UnknownRpcError) instanceof UnknownRpcError
  );
}

export function isInternalRpcError(error: unknown) {
  return (
    error instanceof BaseError &&
    error.walk(e => e instanceof InternalRpcError) instanceof InternalRpcError
  );
}

export function isTransactionNotFoundError(error: unknown) {
  return (
    error instanceof BaseError &&
    error.walk(e => e instanceof TransactionNotFoundError) instanceof TransactionNotFoundError
  );
}
